import { css } from '@emotion/react';
import { SpacingToken } from '@livechat/design-system-react-components';
import { MEDIA_MIN_LG, MEDIA_MIN_SM } from '_assets/css/breakpoints';

export const container = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  max-width: 360px;
  margin-top: 56px;
  padding: 0 var(${SpacingToken.Spacing5});
  gap: var(${SpacingToken.Spacing3});

  ${MEDIA_MIN_SM} {
    margin-top: 118px;
  }
`;

export const textHeader = css`
  font-size: 24px;
  margin-bottom: var(${SpacingToken.Spacing3});
`;

export const tooltipContainer = css`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  cursor: pointer;
`;

export const textContainer = css`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;

export const text = css`
  width: 280px;
`;

export const email = css`
  width: 90vw;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  ${MEDIA_MIN_LG} {
    width: 100%;
    text-overflow: initial;
    overflow: initial;
    white-space: initial;
  }
`;

export const formContainer = css`
  width: 100%;
  padding-top: var(${SpacingToken.Spacing4});

  > form {
    display: flex;
    flex-direction: column;
  }
`;

export const submitButton = css`
  margin-bottom: var(${SpacingToken.Spacing4});
`;
